module.exports = __webpack_public_path__ + "img/Slide14.8a988abb.png";